import React, { useContext } from "react";
import { AuthContext } from "@context/AuthContext";
import CheckoutComplimentary from "@components/CheckoutComplimentary";
import Drawer from "@components/V3/Drawer";

const V3ComplimentaryCheckoutDrawer = ({ uuid, bookingSessionId, session = null }) => {
    const { drawerState, closeDrawer } = useContext(AuthContext);
    
    return (
        <>
            <Drawer
                id="complimentary-checkout-drawer"
                role="dialog"
                aria-modal="true"
                aria-label="Complimentary Checkout Drawer"
                isOpen={drawerState.complimentaryCheckoutDrawer}
                onClose={() => closeDrawer("complimentaryCheckoutDrawer")}
                closeButtonAlignment="right"
            >
                <CheckoutComplimentary
                    uuid={uuid}
                    bookingSessionId={bookingSessionId}
                    session={session}
                />
            </Drawer>
        </>
    );
};

export default V3ComplimentaryCheckoutDrawer;
